export { default as createSellerGdm } from './createSellerGdm';

export type {
  SellerGdmRegisterOnSubmitFunction,
  SellerGdmRegisterOnSubmitPayload,
} from './createSellerGdm.type';
